<template>
  <div>
    <div class="myspinner">
      <atom-spinner
        v-if="loading"
        :animation-duration="speed"
        :size="config.size"
        :color="spinnersColor"
      />
    </div>
    <form @submit.prevent="showOTP ? submitFinal() : onsubmit()">
        <va-input
          v-if="!showOTP"
          v-model="form.memb_no"
          type="text"
          :label="$t('auth.id_no')"
          :error="!!membNoErrors.length"
          :error-messages="membNoErrors"
        />

        <va-input
        v-if="!showOTP"
          v-model="form.phone_no"
          type="text"
          :label="$t('auth.phone_no')"
          :error="!!phoneNoErrors.length"
          :error-messages="phoneNoErrors"
        /> 
        <va-input
        v-if="showOTP"
        v-model="otp"
        type="text"
        :label="$t('auth.otp')"
        :error="!!otpErrors.length"
        :error-messages="otpErrors"
      />    
      <div class="row justify--center">
        <va-button color="#bd174e" type="submit" :disabled="disableButton"  class="my-0">{{ $t('auth.reset_password') }}</va-button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'
export default {
  components: {
    ...spinners      
  },
  name: 'recover-password',
  data () {
    return {
      loading:false,
      showOTP:false,
      disableButton:false,
      otp:'',
      otp_no:'',
      user_id:'',
      company: '',
      form:{
        memb_no:'',
        phone_no: '',
      },
      compName:'',
      phoneNoErrors: [],
      membNoErrors: [],
      errors: [],
      otpErrors: [],
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: "#df902a",
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      },
    }
  },
  computed: {
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },
    formReady () {
      return  !this.phoneNoErrors.length  && !this.membNoErrors.length
    },
  },
  methods: {

    onsubmit () {



      this.membNoErrors = this.form.memb_no ? [] : ['Member No. field is required']
      this.phoneNoErrors = this.form.phone_no ? [] : ['Phone No. is required']

      const data = {
        memb_no: this.form.memb_no,
        phone_no: this.form.phone_no,
        "otp" : "true",
      }


      if (this.formReady) {
        var self = this 
        self.loading = true;  
        self.disableButton = true;  
      
        axios.post(`${this.$apiUrl}RequestPin/`, data)
        .then(function (res) {
          self.loading = false;  
          self.disableButton = false; 
          var response = res.data
          if (response.success === 1) { 
            self.showOTP = true;    
            self.user_id = response.userData;
            self.otp_no = response.otp;
            self.token = response.token;
            self.otpErrors = ['Input OTP'] 
            self.showToast(`Successful! An OTP has been send to your Phone NO. Please input 4 digit OTP to Reset`, {
              position: 'bottom-right',
              icon: "fa-check",
              duration: 10000,
              })
              
              setTimeout( () => self.showOTP = false, 300000);
          }

          if (response.success === 2) {
            self.membNoErrors = ['Account Not Found!']
            self.showToast(`Account Not Found! Confirm Your ID Number and Phone NO by Contact your Sacco  for PIN Reset assistance.`, {
              position: 'bottom-right',
              icon: "fa-times",
              duration: 100000,
            })
          } 

          if (response.success === 3) {
            self.membNoErrors = ['Account is Mobile banking enabled!']
            self.showToast(`Could not complete pin reset due to security reasons please Contact your Sacco for PIN Reset assistance.`, {
              position: 'bottom-right',
              icon: "fa-times",
              duration: 100000,
            })
          } 

        })
   
        .catch(function (error) {
          console.log(error)
        })
      }

    },
    submitFinal(){
      console.log('reached')
      this.otpErrors = this.otp ? [] : ['OTP field field is required']
      const dat = {
          "otp" : this.otp,
          "user_id" : this.user_id,
      };


      if (this.formReady) {
        this.loading = true;       
        var self = this      
        axios.post(`${this.$apiUrl}sendPass`, dat)
        .then(function (res) {
          self.disableButton = false;
          const response = res.data
          self.loading = false;
          if (response.success === 1) {
            self.showToast(`Successful! Your pin has been successfully reset and sent to your phone. Please login and update your pin once you get it`, {
                position: 'bottom-right',
                icon: "fa-check",
                duration: 10000,
              })
              setTimeout( () => self.showOTP = false, 300000);
              self.$router.push({name: "login" });
          } else {                  
            self.otpErrors = [`OTP does not match the one sent you have. Kindy check and try again`];
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        
      }else if(this.retries <= 0){
        this.showOTP = false
      }

    },
  },
}
</script>

<style lang="scss">
.myspinner {
  position: fixed;
  top: 40%;
  left: 22%;
  z-index: 999;
}

@media (max-width: 767px) {
  .myspinner {
    position: fixed;
    top: 38%;
    left: 40%;
    z-index: 999;
  }
}
</style>
